import React, { useContext } from 'react'
import { massProcessingApi } from '@atheneum/api'
import flat from 'flat'
import {
  actions
} from '../listView.reducer'
import { ListViewDispatchContext, ListViewStateContext } from '../listView.context'
import {
  IconButton,
  FormControl,
  Button,
  TextField,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { MoreVert } from '@material-ui/icons'
import _ from 'lodash'
import DeleteSweepOutlinedIcon from '@material-ui/icons/DeleteSweepOutlined'

export function findOccInStatuses(arr) {
  let result = []
  if (!Array.isArray(arr)) return result
  let key = 'description'
  const stalled = {
    description: 'Stalled',
    occurrence: arr.filter(a => a.description?.includes('sherlock')).length
  }
  const nonStalled = arr.filter(a => !a.description?.includes('sherlock'))

  nonStalled.forEach(item => {
    if (
      result.some(val => {
        return val[key] == item[key]
      })
    ) {
      result.forEach(r => {
        if (r[key] === item[key]) {
          r['occurrence']++
        }
      })
    } else {
      let obj = {}
      obj[key] = item[key]
      obj['occurrence'] = 1
      result.push(obj)
    }
  })
  if (stalled.occurrence > 0) return [...result, stalled]
  return [...result]
}

const TooltipContent = items => {
  const statusObj = findOccInStatuses(
    items.filter(item => !!item.data.status).map(item => item.data.status)
  )

  if (!statusObj.length) {
    return (
      <div>
        <p>No Statuses</p>
      </div>
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        minWidth: '100px  '
      }}>
      <div>
        {statusObj.map((s, index) => (
          <p key={index}>{s.description}:</p>
        ))}
      </div>
      <div>
        {' '}
        {statusObj.map((s, index) => (
          <p key={index}>{s.occurrence}</p>
        ))}
      </div>
    </div>
  )
}

export default function ColumnTitle({ column, isDisabled, hoverHeader }) {
  const state = useContext(ListViewStateContext)
  const dispatch = useContext(ListViewDispatchContext)
  const noDeletion = ['checked', 'validation', 'actions', 'status']

  const [removingColumn, setRemovingColumns] = React.useState(false)

      return (
        <>
        {(state.editColumn || column.name === 'actions') ? <span
          style={{
            display: 'flex',
            alignItems: 'center',
            title: 'sort',
            justifyContent: 'space-between'
          }}>
          {state.editColumn? column.title : null}
          {state.editColumn && (
            <>
              {!noDeletion.includes(column.name) && (
                <>
                  {!removingColumn ? (
                    <DeleteSweepOutlinedIcon
                      style={{
                        background: '#fff',
                        position: 'absolute',
                        right: 0
                      }}
                      onClick={async () => {
                        setRemovingColumns(true)
                        await massProcessingApi.updateList({
                          id: state.listId,
                          data: {
                            fields: [
                              ...state._fields.filter(
                                field => field.name !== column.name
                              )
                            ]
                          }
                        })
                        setRemovingColumns(false)
                        return dispatch({
                          type: actions.REMOVE_COLUMN,
                          payload: column.name
                        })
                      }}
                    />
                  ) : (
                    <CircularProgress
                      style={{
                        color: '#429bdc',
                        width: '20px',
                        height: '20px'
                      }}
                    />
                  )}
                </>
              )}
            </>
          )}

        </span> : null}
        </>
        // </ClickAwayListener>
      )
}

function columnActionsReducer(state, { type, payload }) {
  switch (type) {
    case 'close_menu':
      return { ...state, menuAnchor: false }
    case 'open_menu':
      return { ...state, menuAnchor: payload }
    case 'open_create_column':
      return {
        ...state,
        showCreateColumnDialog: true,
        newColumn: { ...columnActionsInitialState.newColumn }
      }
    case 'close_create_column':
      return { ...state, showCreateColumnDialog: false }
    case 'update_create_column_field':
      return {
        ...state,
        newColumn: {
          ...state.newColumn,
          [payload.key]: payload.value
        }
      }
    case 'create_column':
      return {
        ...state,
        newColumn: { ...columnActionsInitialState.newColumn },
        showCreateColumnDialog: false
      }
    case 'remove_column':
      return { ...state }
    default:
      return state
  }
}

const columnActionsInitialState = {
  menuAnchor: null,
  newColumn: { title: '', name: '', type: 'input', width: 250 }
}

export  function ColumnActions({ actions, items }) {
  const [state, dispatch] = React.useReducer(
    columnActionsReducer,
    columnActionsInitialState
  )

  const { title, name } = state.newColumn
  const [addingColumn, setAddingColumn] = React.useState(false)
  const [inputValue, setInputValue] = React.useState('')

  return (
    <>
      <Button
        onClick={() => dispatch({ type: 'open_create_column' })}
        style={{
          textTransform: 'capitalize',
          padding: '1px',
          color: '#33343A',
          marginLeft: '15px'
        }}>
        Add Column
      </Button>
      <Dialog
        onClose={() => dispatch({ type: 'close_create_column' })}
        aria-labelledby="simple-dialog-title"
        open={!!state.showCreateColumnDialog}>
        <DialogTitle id="simple-dialog-title">New Column</DialogTitle>
        <DialogContent>
          <form
            autoComplete="off"
            noValidate
            onSubmit={async e => {
              e.preventDefault()
              setAddingColumn(true)
              await actions.createColumn(state.newColumn)
              dispatch({ type: 'create_column' })
            }}>
            <FormControl fullWidth>
              <TextField
                label="Header Title"
                value={title}
                onChange={e =>
                  dispatch({
                    type: 'update_create_column_field',
                    payload: { key: 'title', value: e.target.value }
                  })
                }
              />
            </FormControl>
            <FormControl fullWidth>
              <Autocomplete
                value={name}
                onChange={(_event, newValue) => {
                  dispatch({
                    type: 'update_create_column_field',
                    payload: { key: 'name', value: newValue }
                  })
                }}
                inputValue={inputValue}
                onInputChange={(_event, newInputValue) => {
                  setInputValue(newInputValue)
                }}
                options={_.uniq([
                  inputValue,
                  ..._(items)
                    .map(i => Object.keys(flat(i.data)))
                    .flattenDeep()
                    .uniq()
                    .value()
                ])}
                getOptionLabel={option => option}
                style={{ width: '100%', maxHeigth: '200px' }}
                renderInput={params => {
                  return (
                    <TextField
                      {...params}
                      placeholder="Field Name"
                      InputProps={{
                        ...params.InputProps
                      }}
                    />
                  )
                }}
              />
            </FormControl>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 15
              }}>
              <Button
                color="primary"
                disabled={!name || !inputValue}
                type="submit">
                {!addingColumn ? (
                  `Create ${title}`
                ) : (
                  <CircularProgress
                    style={{ color: '#429bdc', width: '20px', height: '20px' }}
                  />
                )}
              </Button>
              <Button
                type="button"
                onClick={() => dispatch({ type: 'close_create_column' })}>
                Cancel
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  )
}
